import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    background-color: ${vars.colorDark};
    padding: 0 0 8em;

    .plan-list {
        overflow: hidden;
        display: flex;
        gap: 2em;
        justify-content: center;
        padding-bottom: 2em;

        &__item {
            border-radius: .375em;
            border: 1px solid #4B4B4B;
            background-color: #0E0E0E;
            transition: 150ms;
            padding: 1.25em;
            position: relative;
        }

        .data-type {
            display: block;
            font-weight: 600;
            padding: 0 .275em;

            &.trainer {
                color: ${vars.colorPlanBasic};
            }

            &.high-priest {
                color: ${vars.colorPlanPremium};
            }

            &.sage {
                color: ${vars.colorPlanPremiumLight};
            }
        }

        .data-title {
            color: #FFF;
            font-weight: 500;
            text-align: center;
            font-size: 1.375em;
            margin-bottom: 1em;
            display: flex;
            justify-content: center;
        }

        .inner-price {
            display: flex;
            justify-content: center;
            align-items: baseline;
            color: #FFF;
            margin-bottom: 1.375em;

            .data-price {
                display: block;
                font-size: 2em;
                font-weight: 500;
            }

            .data-price-description {
                display: block;
                font-size: 1.375em;
            }
        }

        .controls-block {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex-direction: column;
            padding: 3em 2em 0;
            margin-bottom: 1em;

            .layout-button {
                width: 100%;

                .button {
                    height: 3em;
                    width: 100%;
                }
            }
        }

        .data-description {
            color: #FFF;
            display: block;
            font-size: 1.325em;
            text-align: center;
            max-width: 70%;
            margin: 0 auto;
            min-height: 6em;

            .data-price {
                display: block;
            }
        }

        .inner-content {
            border-radius: .375em;
            background-color: #181818;
            border: 1px solid rgba(255, 255, 255, 0.1);
            padding: 1em;

            .data-content-title {
                color: #FFF;
                font-weight: 400;
            }

            .list {
                .data-content-title {
                    display: block;
                }

                .list-element {
                    padding: .475em 0;

                    .icon {
                        position: relative;
                        top: 2px;
                        color: #949494;
                        padding-right: .375em;
                    }

                    .data-label {
                        color: #949494;
                        font-size: .825em;
                    }


                    &.active {
                        .icon {
                            color: #A639FF;
                        }

                        .data-label {
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }

    @media all and (max-width: ${vars.tabletS}) {
        padding: 0 0 4em;

        .plan-list {
            flex-direction: column;
        }
    }
`;
